import React from 'react';
import PropTypes from 'prop-types';

import './checkbox.scss';

class CheckboxComponent extends React.Component {
    render() {
        const { name, onChange, checked, placeholder } = this.props;

        return <label className="custom-checkbox">
            <input
                className="checkbox-input"
                name={name}
                type="checkbox"
                checked={checked}
                onChange={onChange}
            />
            <div className="checkbox-icon" />
            {placeholder &&
                <div className="checkbox-placeholder" dangerouslySetInnerHTML={{ __html: placeholder }} />
            }
        </label>;
    }
}

CheckboxComponent.defaultProps = {
    checked: false,
};

CheckboxComponent.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
};

export default CheckboxComponent;



// WEBPACK FOOTER //
// ./src/components/core/CheckboxComponent/CheckboxComponent.js